/* eslint-disable @typescript-eslint/no-explicit-any */
export type IData = {[key:string]:string|number|unknown[], id:string }[];

const isBlank = (value: any): boolean => value === undefined || value === null || value === '';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (dynamicData:any):any => {
  const { headers, fields, code } = dynamicData;
  const data:IData = [];
  dynamicData.records.forEach((facility : any, facilityI:number) => {
    /* Mapping through facilities, creating empty object with ID,name, other values */
    data.push({ id: '' });
    facility.forEach((value : any, i : number) => {
      let key;
      if (code === 'assetTypes') {
        // Property names are verbatim server-side, so `Color` and `color` are separate headers that
        // collapse onto one key here. Keep whichever of them has a value instead of letting the
        // last column win and blank the cell.
        key = headers[i].toLowerCase();
        if (!isBlank(data[facilityI][key]) && isBlank(value)) {
          return;
        }
      } else {
        key = fields ? fields[i] : headers[i];
      }
      data[facilityI][key] = value;
    });
  });
  return data;
};
